module.exports = __webpack_public_path__ + "static/media/rhok.33b46b71.mp4";